import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { CreateAgencyComponent } from './create-agency.component';
import { AgentGridComponent } from './agent-grid/agent-grid.component';
/*import { CreateAgencyFormComponent } from './create-agency-form/create-agency-form.component';*/
import { CreateAgencyRoutingModule } from './create-agency-routing.module';
import { AgencyService } from "./shared/agency.service";
import { TopUpComponent } from './top-up/top-up.component';
import { TopUpService } from "./top-up/top-up.service";

@NgModule({
  imports: [
    CommonModule,
    CreateAgencyRoutingModule,
    SharedModule
  ],
  declarations: [ 
  	CreateAgencyComponent,
  	AgentGridComponent,
  	TopUpComponent,
    /*CreateAgencyFormComponent*/
    ],
  providers: [AgencyService, TopUpService],
})
export class CreateAgencyModule { }



// WEBPACK FOOTER //
// C:/Agent0/_work/434/s/src/app/create-agency/create-agency.module.ts